<template>
  <div class="pos-devices-tab col-12">
    <placeholder-content v-if="loading" :is-load="true" />
    <access-denied v-else-if="!hasPermission" />

    <template v-else>
      <div class="text-muted mb-2" style="font-size: 13px;">
        {{ $t('Devices that issue abbreviated tax invoices at this branch.') }}
      </div>

      <div class="d-flex justify-content-end mb-2">
        <button type="button" class="btn btn-sm btn-primary" :disabled="editingId !== null" @click="addRow">
          <i class="fa-solid fa-plus me-1" />
          {{ $t('Add POS Device') }}
        </button>
      </div>

      <!--
        table-responsive — จอมือถือตารางนี้ล้นออกนอกกรอบ offcanvas (8 คอลัมน์ มี input ด้วย)
        ห่อไว้ให้เลื่อนแนวนอนในกรอบตัวเอง แทนที่จะดันทั้งหน้าให้กว้างเกิน
        min-width กันไม่ให้คอลัมน์ถูกบีบจนกรอกไม่ได้บนจอแคบ
      -->
      <div class="table-responsive">
      <table class="table table-sm align-middle mb-2" style="min-width: 1260px;">
        <thead>
          <!--
            ยี่ห้อ/รุ่น/เลขเครื่อง ที่ต้องประกาศในแบบ ภ.พ.06 แยกเป็น 3 คอลัมน์ใต้หัวรวม
            เคยยัดไว้ช่องเดียวแบบซ้อน 3 ชั้น แล้วแถวสูงไม่เท่ากันจนช่องอื่นลอยไปคนละระดับ
            — แยกคอลัมน์แล้วทุกช่องสูงเท่ากันบรรทัดเดียวทั้งตอนดูและตอนแก้
          -->
          <tr class="text-muted" style="font-size: 12px;">
            <th rowspan="2" class="align-bottom" style="width: 15%;">{{ $t('Device Name') }}</th>
            <th rowspan="2" class="align-bottom" style="width: 13%;">{{ $t('POS Code from Revenue Department') }}</th>
            <th colspan="3" class="text-center border-bottom-0 pb-0" style="width: 40%;">
              {{ $t('Device Details for Phor.Phor.06') }}
            </th>
            <th rowspan="2" class="align-bottom text-center" style="width: 8%;">{{ $t('Active') }}</th>
            <!-- บิลที่ไม่ได้ปิดที่เครื่องไหน (รับเงินหลังร้าน / ออเดอร์เดลิเวอรี่) จะมาผูกกับเครื่องนี้ -->
            <th rowspan="2" class="align-bottom text-center" style="width: 10%;">{{ $t('Default Device') }}</th>
            <th rowspan="2" class="align-bottom" style="width: 16%;">{{ $t('This Computer') }}</th>
            <th rowspan="2" class="align-bottom text-end" style="width: 8%;"></th>
          </tr>
          <tr class="text-muted" style="font-size: 12px;">
            <th class="fw-normal pt-0" style="width: 11%;">{{ $t('Brand') }}</th>
            <th class="fw-normal pt-0" style="width: 13%;">{{ $t('Model') }}</th>
            <th class="fw-normal pt-0" style="width: 16%;">{{ $t('Serial Number') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!items.length && editingId === null">
            <td colspan="9" class="text-center text-muted py-3" style="font-size: 13px;">
              {{ $t('No POS device registered — receipts will print the POS line without a code.') }}
            </td>
          </tr>

          <tr v-for="item in items" :key="item.id">
            <!-- ===== แถวที่กำลังแก้ ===== -->
            <template v-if="editingId === item.id">
              <td>
                <div class="custom-input-group input-group input-group-sm">
                  <input
                    type="text"
                    v-model.trim="draft.name"
                    class="form-control form-control-sm"
                    :placeholder="$t('e.g. Cashier 1')"
                    @keyup.enter="saveRow"
                    @keyup.esc="cancelRow"
                  >
                </div>
              </td>
              <td>
                <div class="custom-input-group input-group input-group-sm">
                  <input
                    type="text"
                    maxlength="50"
                    v-model.trim="draft.rd_device_code"
                    class="form-control form-control-sm"
                    :placeholder="$t('Not registered')"
                    @keyup.enter="saveRow"
                    @keyup.esc="cancelRow"
                  >
                </div>
              </td>
              <td>
                <div class="custom-input-group input-group input-group-sm">
                  <input
                    type="text"
                    maxlength="100"
                    v-model.trim="draft.device_brand"
                    class="form-control form-control-sm"
                    :placeholder="$t('Optional')"
                    @keyup.enter="saveRow"
                    @keyup.esc="cancelRow"
                  >
                </div>
              </td>
              <td>
                <div class="custom-input-group input-group input-group-sm">
                  <input
                    type="text"
                    maxlength="100"
                    v-model.trim="draft.device_model"
                    class="form-control form-control-sm"
                    :placeholder="$t('Optional')"
                    @keyup.enter="saveRow"
                    @keyup.esc="cancelRow"
                  >
                </div>
              </td>
              <td>
                <div class="custom-input-group input-group input-group-sm">
                  <input
                    type="text"
                    maxlength="100"
                    v-model.trim="draft.device_serial"
                    class="form-control form-control-sm"
                    :placeholder="$t('Optional')"
                    @keyup.enter="saveRow"
                    @keyup.esc="cancelRow"
                  >
                </div>
              </td>
              <td class="text-center">
                <div class="form-check form-switch d-inline-block m-0">
                  <input class="form-check-input" type="checkbox" v-model="draft.is_active">
                </div>
              </td>
              <td class="text-center">
                <input
                  class="form-check-input mt-0"
                  type="checkbox"
                  v-model="draft.is_default"
                  :disabled="!draft.is_active"
                >
              </td>
              <td></td>
              <td class="text-end text-nowrap">
                <button type="button" class="btn btn-sm btn-primary me-1" :disabled="saving" @click="saveRow">
                  <i class="fa-solid fa-check" />
                </button>
                <button type="button" class="btn btn-sm btn-light border" :disabled="saving" @click="cancelRow">
                  <i class="fa-solid fa-xmark" />
                </button>
              </td>
            </template>

            <!-- ===== แถวปกติ ===== -->
            <template v-else>
              <td>{{ item.name }}</td>
              <td>
                <span v-if="item.rd_device_code">{{ item.rd_device_code }}</span>
                <span v-else class="text-muted">{{ $t('Not registered') }}</span>
              </td>
              <td :class="item.device_brand ? '' : 'text-muted'">{{ item.device_brand || '-' }}</td>
              <td :class="item.device_model ? '' : 'text-muted'">{{ item.device_model || '-' }}</td>
              <td :class="item.device_serial ? '' : 'text-muted'">{{ item.device_serial || '-' }}</td>
              <td class="text-center">
                <span :class="item.is_active ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ item.is_active ? $t('Active') : $t('Inactive') }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="item.is_default" class="badge bg-primary">
                  <i class="fa-solid fa-star me-1" />
                  {{ $t('Default') }}
                </span>
                <span v-else class="text-muted">-</span>
              </td>
              <td>
                <!--
                  ปุ่มนี้ผูก "คอมที่กำลังเปิดหน้านี้อยู่" ไม่ใช่เครื่องอื่น — ต้องเดินไปกดที่เครื่องนั้นจริงๆ
                  (api/docs/vat-compliance.md D10)
                -->
                <span v-if="isThisComputer(item)" class="badge bg-success">
                  <i class="fa-solid fa-desktop me-1" />
                  {{ $t('This Computer') }}
                </span>
                <template v-else>
                  <button
                    type="button"
                    class="btn btn-sm btn-light border text-nowrap"
                    :disabled="!item.is_active || claimingId === item.id || editingId !== null"
                    :title="item.is_claimed
                      ? $t('In use elsewhere') + (item.last_seen_at ? ' — ' + formatDateTime(item.last_seen_at) : '')
                      : ''"
                    @click="handleClaim(item)"
                  >
                    <i class="fa-solid fa-desktop me-1 text-secondary" />
                    {{ $t('Use this computer') }}
                    <!-- เครื่องนี้มีเบราว์เซอร์อื่นถืออยู่ — เตือนในปุ่มเลย แถวจะได้ไม่สูงขึ้น -->
                    <i
                      v-if="item.is_claimed"
                      class="fa-solid fa-triangle-exclamation ms-1 text-warning"
                    />
                  </button>
                </template>
              </td>
              <td class="text-end text-nowrap">
                <!--
                  ใบตัวอย่างสำหรับแนบคำขอ ภ.พ.06 — ไม่แตะ DB ไม่เดินเลขใบกำกับ
                  (ถ้าไม่มีปุ่มนี้ ร้านต้องขายจริงแล้วยกเลิกเพื่อเอาใบไปยื่น = เผาเลขทิ้ง 1 ใบ)
                -->
                <button
                  type="button"
                  class="btn btn-sm btn-light border me-1"
                  :title="$t('Print sample receipt for the Phor.Phor.06 application')"
                  :disabled="editingId !== null || printingId !== null"
                  @click="handlePrintSample(item)"
                >
                  <i
                    class="fa-solid"
                    :class="printingId === item.id ? 'fa-spinner fa-spin' : 'fa-print'"
                  />
                </button>
                <button
                  v-if="isThisComputer(item)"
                  type="button"
                  class="btn btn-sm btn-light border me-1"
                  :title="$t('Unlink')"
                  :disabled="editingId !== null"
                  @click="handleRelease(item)"
                >
                  <i class="fa-solid fa-link-slash" />
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-light border me-1"
                  :disabled="editingId !== null"
                  @click="editRow(item)"
                >
                  <i class="fa-solid fa-pen" />
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-light border text-danger"
                  :disabled="editingId !== null"
                  @click="handleDelete(item)"
                >
                  <i class="fa-solid fa-trash-can" />
                </button>
              </td>
            </template>
          </tr>

          <!-- ===== แถวเครื่องใหม่ — เพิ่มในตารางเลย ไม่ต้องไปหน้าอื่น ===== -->
          <tr v-if="editingId === 'new'">
            <td>
              <div class="custom-input-group">
                <input
                  type="text"
                  v-model.trim="draft.name"
                  class="form-control form-control-sm"
                  :placeholder="$t('e.g. Cashier 1')"
                  ref="newNameInput"
                  @keyup.enter="saveRow"
                  @keyup.esc="cancelRow"
                >
              </div>
            </td>
            <td>
              <div class="custom-input-group">
                <input
                  type="text"
                  maxlength="50"
                  v-model.trim="draft.rd_device_code"
                  class="form-control form-control-sm"
                  :placeholder="$t('Not registered')"
                  @keyup.enter="saveRow"
                  @keyup.esc="cancelRow"
                >
              </div>
            </td>
            <td>
              <div class="custom-input-group">
                <input
                  type="text"
                  maxlength="100"
                  v-model.trim="draft.device_brand"
                  class="form-control form-control-sm"
                  :placeholder="$t('Optional')"
                  @keyup.enter="saveRow"
                  @keyup.esc="cancelRow"
                >
              </div>
            </td>
            <td>
              <div class="custom-input-group">
                <input
                  type="text"
                  maxlength="100"
                  v-model.trim="draft.device_model"
                  class="form-control form-control-sm"
                  :placeholder="$t('Optional')"
                  @keyup.enter="saveRow"
                  @keyup.esc="cancelRow"
                >
              </div>
            </td>
            <td>
              <div class="custom-input-group">
                <input
                  type="text"
                  maxlength="100"
                  v-model.trim="draft.device_serial"
                  class="form-control form-control-sm"
                  :placeholder="$t('Optional')"
                  @keyup.enter="saveRow"
                  @keyup.esc="cancelRow"
                >
              </div>
            </td>
            <td class="text-center">
              <div class="form-check form-switch d-inline-block m-0">
                <input class="form-check-input" type="checkbox" v-model="draft.is_active">
              </div>
            </td>
            <td class="text-center">
              <input
                class="form-check-input mt-0"
                type="checkbox"
                v-model="draft.is_default"
                :disabled="!draft.is_active"
              >
            </td>
            <td></td>
            <td class="text-end text-nowrap">
              <button type="button" class="btn btn-sm btn-primary me-1" :disabled="saving" @click="saveRow">
                <i class="fa-solid fa-check" />
              </button>
              <button type="button" class="btn btn-sm btn-light border" :disabled="saving" @click="cancelRow">
                <i class="fa-solid fa-xmark" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <div class="form-text">
        {{ $t('Leave blank if you have not registered this device with the Revenue Department.') }}
      </div>
      <!--
        ตอนยื่น ภ.พ.06 ยังไม่มีเลขประจำเครื่อง (สรรพากรออกให้หลังอนุมัติ) และออกใบกำกับ
        จริงก็ยังไม่ได้ — ปุ่มพิมพ์ใบตัวอย่างจึงมีไว้เพื่อการนี้โดยเฉพาะ ต้องบอกให้คนใช้รู้
      -->
      <div class="form-text">
        <i class="fa-solid fa-print me-1" />
        {{ $t('Use the print button to produce the sample abbreviated tax invoice required by the Phor.Phor.06 application.') }}
      </div>
      <!--
        สรรพากรถือว่าทุกบาทที่ขายผ่าน POS ต้องบอกได้ว่ามาจากเครื่องหมายเลขอะไร
        แถว "ไม่ระบุเครื่อง" ในรายงานภาษีขายจึงเสี่ยงถูกตีกลับ — ตั้งเครื่องเริ่มต้นแล้วหายไป (D13)
      -->
      <div class="form-text">
        <i class="fa-solid fa-star me-1" />
        {{ $t('Bills closed outside a POS terminal (back office or delivery platform) are attributed to the default device.') }}
      </div>
    </template>
  </div>
</template>

<script lang="js">
/**
 * ทะเบียนเครื่อง POS ของสาขา (silver-spoon-api/docs/vat-compliance.md D10)
 *
 * ร้านที่ยื่นขออนุมัติใช้เครื่องบันทึกการเก็บเงิน (ภ.พ.06) เอาเลขประจำเครื่องมาลงที่นี่
 * แล้วใบกำกับภาษีอย่างย่อจะพิมพ์บรรทัด "POS : xxx" ให้
 *
 * ⚠️ เป็นข้อมูลเสริม ไม่ใช่ประตูกั้น — ร้านที่ไม่ได้ยื่นก็ขายและออกใบกำกับได้ตามปกติ
 * แค่บรรทัด POS เว้นว่างไว้ (ร้านจริงส่วนใหญ่ไม่ได้ยื่น)
 *
 * ปุ่ม "ใช้คอมเครื่องนี้" จองทะเบียนให้ browser ที่กำลังเปิดหน้าอยู่ แล้วเก็บ token ลง
 * localStorage — พอไปหน้า POS axios จะแนบ token ให้เอง ไม่ต้องมีหน้าเลือกเครื่องแยก
 */
import moment from 'moment';
import { Branches } from '@/services/endpoint/branches.service';
import { getPosDevice, setPosDevice, clearPosDevice } from '@/services/posDevice';
import { printSampleReceipt } from '@/utils/sampleReceipt';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from '@/plugins/AccessDenied.vue';

export default {
  name: 'PosDevicesTab',
  components: { PlaceholderContent, AccessDenied },
  props: {
    branchId: {
      type: Number,
      required: true
    },
    // ค่าที่กำลังตั้งอยู่บนฟอร์มสาขา (ยังไม่กดบันทึกก็ใช้พิมพ์ตัวอย่างได้)
    // ส่งลงมาแทนที่จะยิง API ซ้ำ — หน้าแม่โหลดมาแล้วทั้งก้อน
    branchConfig: {
      type: Object,
      default: () => ({})
    },
    // filter.shop_tax — ชื่อผู้ประกอบการ/เลขผู้เสียภาษีที่ต้องพิมพ์บนใบตัวอย่าง
    shopTax: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: true,
      hasPermission: false,
      saving: false,
      claimingId: null,
      printingId: null,
      items: [],
      // null = ไม่ได้แก้อะไรอยู่ · 'new' = กำลังเพิ่มเครื่องใหม่ · <id> = กำลังแก้แถวนั้น
      editingId: null,
      draft: { name: '', rd_device_code: '', device_brand: '', device_model: '', device_serial: '', is_active: true, is_default: false },
      // เครื่องที่คอมเครื่องนี้จองไว้ (localStorage) — ไม่ใช่ state ของหน้า
      thisComputer: getPosDevice(),
    };
  },
  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
  methods: {
    formatDateTime(value) {
      return value ? moment(value).format('YYYY-MM-DD HH:mm') : '-';
    },
    isThisComputer(item) {
      return this.thisComputer?.id === item.id;
    },
    /**
     * พิมพ์ใบกำกับภาษีอย่างย่อ "ตัวอย่าง" ของเครื่องนี้ เพื่อแนบคำขอ ภ.พ.06
     * ข้อมูลร้านของจริง · รายการสมมุติ · ไม่แตะ DB เลย (ดู utils/sampleReceipt.js)
     */
    async handlePrintSample(item) {
      if (this.printingId !== null) return;
      this.printingId = item.id;
      try {
        await printSampleReceipt({
          branchConfig: this.branchConfig,
          shopTax: this.shopTax,
          device: item,
          fmt: (v) => this.$storeIndex.formatThaiCurrency(v),
          t: (s) => this.$t(s),
        });
      } catch (e) {
        console.error('Sample receipt print error:', e);
        this.$toast.error(this.$t('Print failed') + ': ' + (e.message || e));
      } finally {
        this.printingId = null;
      }
    },
    async fetchData() {
      await Branches.getPosDevices(this.branchId).then(res => {
        this.items = res.data.data || [];
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) this.hasPermission = false;
        else throw err;
      });
    },
    addRow() {
      this.editingId = 'new';
      this.draft = { name: '', rd_device_code: '', device_brand: '', device_model: '', device_serial: '', is_active: true, is_default: false };
      this.$nextTick(() => this.$refs.newNameInput?.focus());
    },
    editRow(item) {
      this.editingId = item.id;
      this.draft = {
        name: item.name,
        rd_device_code: item.rd_device_code || '',
        // ฮาร์ดแวร์ที่ประกาศใน ภ.พ.06 — แก้ในแถวเดิมได้เหมือนช่องอื่น
        device_brand: item.device_brand || '',
        device_model: item.device_model || '',
        device_serial: item.device_serial || '',
        is_active: item.is_active,
        is_default: item.is_default,
      };
    },
    cancelRow() {
      this.editingId = null;
    },
    async saveRow() {
      if (this.saving) return;
      if (!this.draft.name) {
        this.$toast.warn(this.$t('Please enter a device name.'));
        return;
      }

      this.saving = true;
      // payload ตรงๆ — API ปฏิเสธ key ที่ไม่รู้จัก
      const params = {
        name: this.draft.name,
        rd_device_code: this.draft.rd_device_code || null,
        device_brand: this.draft.device_brand || null,
        device_model: this.draft.device_model || null,
        device_serial: this.draft.device_serial || null,
        is_active: this.draft.is_active,
        is_default: this.draft.is_default,
      };
      const call = this.editingId === 'new'
        ? Branches.createPosDevice(this.branchId, params)
        : Branches.updatePosDevice(this.branchId, this.editingId, params);

      await call.then(async () => {
        this.$toast.success('<B>' + this.$t('Success') + '</B>\n' + this.$t('Save Success!'));
        this.editingId = null;
        await this.fetchData();
      }).catch(err => {
        // ชื่อ/เลขซ้ำ → คาแถวไว้ให้แก้ต่อ ไม่ปิด draft ทิ้ง
        if (err?.response?.data?.message) this.$toast.warn(this.$t(err.response.data.message));
      }).finally(() => {
        this.saving = false;
      });
    },
    async handleClaim(item) {
      // เครื่องนี้มีเบราว์เซอร์อื่นถืออยู่ = ยึดเครื่อง ตัวเก่าหลุดทันที ต้องถามก่อน
      if (item.is_claimed) {
        const self = this;
        this.$swal({
          icon: 'warning',
          iconColor: '#FF7043',
          title: this.$t('Take over this device') + '?',
          html: this.$t('Another computer is using it and will stop printing the POS code.'),
          showCancelButton: true,
          cancelButtonText: this.$t('Cancel'),
          confirmButtonText: '<i class="fas fa-check-circle me-1"></i>' + this.$t('Confirm'),
          buttonsStyling: false,
          customClass: { confirmButton: 'btn btn-primary me-2', cancelButton: 'btn btn-danger' },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: () => self.claim(item),
        });
        return;
      }
      await this.claim(item);
    },
    async claim(item) {
      this.claimingId = item.id;
      await Branches.claimPosDevice(this.branchId, item.id).then(async res => {
        const d = res.data?.data ?? res.data;
        setPosDevice({
          id: d.id,
          name: d.name,
          rd_device_code: d.rd_device_code,
          device_token: d.device_token,
        });
        this.thisComputer = getPosDevice();
        this.$toast.success('<B>' + this.$t('Success') + '</B>\n' + this.$t('This computer is now') + ': ' + d.name);
        await this.fetchData();
      }).catch(err => {
        if (err?.response?.data?.message) this.$toast.warn(this.$t(err.response.data.message));
      }).finally(() => {
        this.claimingId = null;
      });
    },
    async handleRelease(item) {
      await Branches.releasePosDevice(this.branchId, item.id).then(async () => {
        clearPosDevice();
        this.thisComputer = null;
        this.$toast.success('<B>' + this.$t('Success') + '</B>\n' + this.$t('Unlink'));
        await this.fetchData();
      }).catch(err => {
        if (err?.response?.data?.message) this.$toast.warn(this.$t(err.response.data.message));
      });
    },
    async handleDelete(item) {
      const self = this;
      this.$swal({
        icon: 'warning',
        iconColor: '#FF7043',
        title: this.$t('Delete this POS Device') + '?',
        html: this.$t('You will not be able to undo this action.'),
        showCancelButton: true,
        cancelButtonText: this.$t('Cancel'),
        confirmButtonText: '<i class="fas fa-check-circle me-1"></i>' + this.$t('Confirm'),
        buttonsStyling: false,
        customClass: { confirmButton: 'btn btn-primary me-2', cancelButton: 'btn btn-danger' },
        focusConfirm: false,
        showLoaderOnConfirm: true,
        preConfirm: async function () {
          return Branches.deletePosDevice(self.branchId, item.id)
            .then(async () => {
              if (self.isThisComputer(item)) {
                clearPosDevice();
                self.thisComputer = null;
              }
              self.$toast.success('<B>' + self.$t('Success') + '</B>\n' + self.$t('Delete Success!'));
              await self.fetchData();
            })
            .catch((error) => {
              if (error?.response?.data?.message) self.$toast.warn(self.$t(error.response.data.message));
            });
        },
      });
    },
  }
};
</script>
